<div class="ml-5">
  <p class="titre1 m-4">
    {{ 'PROFIL_UTILISATEUR.TITLE_PARAMETRE' | translate }}
    <mat-icon class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">manage_accounts</mat-icon>
  </p>
</div>
@if (isLoading) {
  <div class="flex justify-center items-center h-64">
    <mat-spinner color="accent"></mat-spinner>
  </div>
}
@if (!isLoading) {
  <h2 class="titre2 text-center">{{ 'PROFIL_UTILISATEUR.PARAMETRE_REGLAGES' | translate }}</h2>
  <div class="flex justify-center min-h-screen">
    <div class="rounded-xl p-4 m-4 border border-gray-300 h-fit w-fit">
      <div class="flex items-center space-x-2 mb-3">
        <label for="utilisateurId" class="font-semibold text-xl">{{ 'PROFIL_UTILISATEUR.PARAMETRE_ID' | translate }} :</label>
        <div id="utilisateurId" class="text-xl">{{parametreUtilisateur.utilisateurId | tiret}}</div>
      </div>
      <div class="flex items-center space-x-2 mb-3">
        <label for="prenom" class="font-semibold text-xl">{{ 'PROFIL_UTILISATEUR.PARAMETRE_PRENOM' | translate }} : </label>
        <div id="prenom" class="text-xl">{{parametreUtilisateur.prenom | tiret}}</div>
      </div>
      <div class="flex items-center space-x-2 mb-3">
        <label for="nom" class="font-semibold text-xl">{{ 'PROFIL_UTILISATEUR.PARAMETRE_NOM' | translate }} : </label>
        <div id="nom" class="text-xl">{{parametreUtilisateur.nom | tiret}}</div>
      </div>
      <div class="flex items-center space-x-2 mb-3">
        <label for="adresseCourriel" class="font-semibold text-xl">{{ 'PROFIL_UTILISATEUR.PARAMETRE_ADRESSE_COURRIEL' | translate }} : </label>
        <div id="adresseCourriel" class="text-xl"> {{parametreUtilisateur.adresseCourriel | tiret}}</div>
      </div>
      <div class="flex items-center space-x-2 mb-3">
        <label for="telephone" class="font-semibold text-xl">{{ 'PROFIL_UTILISATEUR.PARAMETRE_TELEPHONE' | translate }} : </label>
        <div id="telephone" class="text-xl">{{parametreUtilisateur.telephone | tiret }}</div>
      </div>
      <div class="flex items-center space-x-2 mb-3">
        <label for="dateDerniereConnexion" class="font-semibold text-xl">{{ 'PROFIL_UTILISATEUR.PARAMETRE_DATEDERNIERECONNEXION' | translate }} : </label>
        <div id="dateDerniereConnexion" class="text-xl">{{parametreUtilisateur.dateDerniereConnexion | date:'yyyy-MM-dd '}}</div>
      </div>
      <div class="flex items-center space-x-2 mb-3">
        <label for="dateCreation" class="font-semibold text-xl">{{ 'PROFIL_UTILISATEUR.PARAMETRE_DATECREATION' | translate }} : </label>
        <div id="dateCreation" class="text-xl">{{parametreUtilisateur.dateCreation | date:'yyyy-MM-dd '}}</div>
      </div>
      <div class="flex items-center space-x-2 mb-3">
        <label for="langue" class="font-semibold text-xl">{{ 'PROFIL_UTILISATEUR.PARAMETRE_LANGUE' | translate }} : </label>
        <div id="langue" class="text-xl">{{ parametreUtilisateur.langue | tiret }}</div>
      </div>
    </div>
  </div>
  <div class="flex justify-end px-3 mt-4">
    <a (click)="retour()">
      <button class="btn-secondary-novo">{{ 'PROFIL_UTILISATEUR.DOCUMENT_RETOUR' | translate }}</button>
    </a>
  </div>
}


